// removed by extract-text-webpack-plugin
module.exports = {"container":"c241381c57_src-common-_Box_container","onDarkBackground":"_24e7d0cb83_src-common-_Box_onDarkBackground","thingy":"_69cc0799b1_src-common-_Box_thingy"};


//////////////////
// WEBPACK FOOTER
// ./src/common/Box.css
// module id = 921
// module chunks = 0